import { type PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

import { Drawer as MDrawer } from "@mantine/core";

interface Props {
  isOpen: boolean;
  position?: "left" | "right" | "top" | "bottom";
  size?: string;
  contentClassName?: string;
  innerClassName?: string;
  onClose: () => void;
  bodyClassName?: string;
  closeOnClickOutside?: boolean;
}

export const Drawer = ({
  isOpen,
  position = "right",
  size = "calc(100% - 110px)",
  children,
  contentClassName,
  innerClassName,
  onClose,
  bodyClassName,
  closeOnClickOutside = false,
}: PropsWithChildren<Props>) => {
  return (
    <MDrawer
      opened={isOpen}
      onClose={onClose}
      position={position}
      overlayProps={{ backgroundOpacity: 0 }}
      withCloseButton={false}
      closeOnClickOutside={closeOnClickOutside}
      size={size}
      classNames={{
        inner: twMerge("mt-[76px] overflow-hidden", innerClassName),
        content: twMerge(
          "shadow-[0_0_30px] shadow-v2-black/15% bg-v2-glass-inverse backdrop-blur-sm",
          contentClassName,
        ),
        body: twMerge("flex flex-col gap-2 p-6 h-full", bodyClassName),
      }}
      styles={{
        root: {
          position: "absolute",
          top: "76px",
          height: "calc(100% - 76px)",
        },
        overlay: {
          position: "absolute",
          top: "76px",
          height: "calc(100% - 76px)",
        },
      }}
    >
      {children}
    </MDrawer>
  );
};
